export default "__VITE_ASSET__e04e38dc__"